import React, {useState, useEffect} from "react";
import CustomDropdown from "../../components/CustomDropdown";
import NewCustomDropdown from "../../components/NewCustomDropdown";
import axios from '../../backendClient'; 
import User from "./User";



const Cards = () => {
 const offerDropItems = ['drop1', 'drop2', 'drop3']; 

 const [options, setOptions] = useState([{list: 'Select Your Offers', value: ''} ]);
 const [selectedId, setSelectedId] = useState('');

 // Metrics state
 const [title, setTitle] = useState(''); 
 const [ticketsSold, setTicketsSold] = useState(0);
 const [totalSalesCents, setTotalSalesCents] = useState(0);
 const [maxCapacity, setMaxCapacity] = useState(0);
 const [guestReviews, setGuestReviews] = useState([]); 

 //get endPoint for all events 
 useEffect(() => {
  let cancel = false;
  (async () => {
    try {
      const { data } = await axios.get('/api/events/dropdownEvents');
      const list = (data?.events || []).map(e => ({
        label: e.title,
        value: e.eventId,
      }));
      if (!cancel) {
        setOptions(prev => (list.length ? list : prev));
        if (list[0]) setSelectedId(list[0].value);
      }
    } catch (e) {
      // keep default placeholder if error
    }
  })();
  return () => { cancel = true; };
}, []);

useEffect(() => {
  if (!selectedId) return;
  let cancel = false;
  (async () => {
    try {
      const { data } = await axios.post(`/api/events/getMetrics`, {eventId: selectedId});
      if (!cancel && data?.ok && data.event) {
        setTitle(data.event.title || ''); 
        setTicketsSold(data.event.ticketsSold || 0);
        setTotalSalesCents(data.event.totalSalesAmount || 0);
        setMaxCapacity(data.event.maxCapacity || 0);
        setGuestReviews(data.event.guestsDetailed || []); 
      }
    } catch (e) {
      // reset on error (optional)
      if (!cancel) {
        setTicketsSold(0);
        setTotalSalesCents(0);
        setMaxCapacity(0);
        setGuestReviews([]); 
        setTitle(""); 
      }
    }
  })();
  return () => { cancel = true; };
}, [selectedId]);

  return (
    <>
    <div
      id="dashbord_cards"
      style={{ maxWidth: "1360px", paddingLeft: "20px", paddingRight: "20px" }}
      className=" mx-auto py-3  py-md-4 mt-2 mt-md-5 pt-5">
            <h6 className="mb-0">Payouts will be made within 48-72 hours after Event End to Zelle or Venmo on Host Profile. Your account manager may reach out.</h6>
      <NewCustomDropdown
        customStyles="mt-3 mt-md-4"
        title="Select Offers"
        itemList={options}              // [{label, value}]
        onSelect={(opt) => setSelectedId(opt.value)} // <-- make sure CustomDropdown calls onSelect with the whole option or value
        />
      <div className="row pt-3 pt-md-4">
        <div className="col-4 ">
          <div className="card__dashbord ">
            <p className=" mb-0">Event</p>
            <h4 className="mb-0">{title}</h4>
          </div>
        </div>
        <div className="col-4">
          <div className="card__dashbord">
            <p className=" mb-0">Tickets Sold</p>
            <h2 className="mb-0">{ticketsSold}</h2>
          </div>
        </div>
        <div className="col-4">
          <div className="card__dashbord">
            <p className=" mb-0">Total Net Payout (after fees)</p>
            <h2 className="mb-0 color_green">${totalSalesCents * .8}</h2>
          </div>
        </div>
        <div className="col-6 mt_custom mt-sm-3 mt-md-4">
          <div className="card__dashbord">
            <div className=" d-flex  justify-content-between mb-0 position-relative w-100 pt-2 pt-sm-0">
              <p className=" mb-0">Max Capacity</p>
              <div className="btn_select  gap-2 d-none d-sm-flex align-items-center scale-down-desktop">
                <label className="switch">
                  <input type="checkbox" />
                  <span className="slider round"></span>
                </label>
                <p className=" mb-0 ps-1">Confirmed</p>
              </div>
            </div>

            <div className="d-flex justify-content-between w-100 align-items-center">
              {" "}
              <h2 className="mb-0">{maxCapacity}</h2>{" "}
              <div className="btn_select  gap-2 d-flex d-sm-none align-items-center position-relative scale-down-desktop">
                <label className="switch">
                  <input type="checkbox" />
                  <span className="slider round"></span>
                </label>
                <p className=" mb-0 ps-1">Confirmed</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-6 mt_custom mt-sm-3 mt-md-4">
          <div className="card__dashbord">
            <div className=" d-flex justify-content-between mb-0">
              <p className=" mb-0">% Change Week over Week</p>
            </div>
            <h2 className="mb-0">0%</h2>
          </div>
        </div>
      </div>
    </div>
    <User guestsDetail = {guestReviews}/>
  </>
  );
};

export default Cards;
